export default {
  time: {
    crud: {
      create_overtime: "Fazla Mesai Talebi Oluştur"
    },
    event: {
      clock_in: "Giriş",
      clock_out: "Çıkış",
      duty_in: "Görev Giriş",
      training_in: "Eğitim Giriş",
      training_out: "Eğitim Çıkış",
      home_duty_in: "Evden Mesai Giriş",
      duty_out: "Görev Çıkış",
      home_duty_out: "Evden Mesai Çıkış",
      break_in: "Mola Giriş",
      break_out: "Mola Çıkış",
      lunch_in: "Yemek Giriş",
      lunch_out: "Yemek Çıkış"
    },
    menu: {
      shifts: "Vardiyalar",
      timesheets: "Zaman Çizelgesi",
      overtime_requests: "Fazla Mesailer",
      overtime_approval: "Onay Bekleyen Talepler",
      employee_calendar: "Çalışan Takvimi"
    },
    shift_types: {
      FIX: "Sabit",
      FLEXIBLE: "Esnek",
      OFF_DAY: "Hafta Tatili",
      OFFDAY: "Hafta Tatili",
      HOLIDAY: "Resmi Tatili",
      WORKDAY: "İş Günü",
      BREAK: "Dinlenme Günü"
    },
    overtime_approval: {
      employee: "Çalışan",
      workplan: "Vardiya",
      request_status: "Durum",
      reason: "Sebep",
      request_time: "Talep Tarihi",
      approval_message:
        "{0} {1} tarihindeki vardiyası için {2} dakika <span class='red--text font-weight-bold'>{3}</span> fazla mesaiyi onaylamak istiyor musunuz?",
      shift_type: {
        workday: "Çalışma Günü",
        offday: "Hafta Tatili",
        holiday: "Resmi Tatil"
      },
      overtime_approval: "Fazla Mesai Onaylama"
    },
    overtime_request: {
      approve_title: "Fazla Mesai Onaylama",
      add_overtime: "Fazla Mesai Talebi Oluştur",
      date: "Vardiya Tarihi",
      workplan: "Vardiya",
      overtime_in_minutes: "Mesai Süresi",
      short_minute: "dk",
      request_status: "Durum",
      request_date: "Talep Tarihi",
      period: "Periyod",
      periods: {
        CLOCK_IN: "Mesai Giriş",
        CLOCK_OUT: "Mesai Çıkış",
        CLOCK_IN_OUT: "Mesai Giriş & Çıkış"
      },
      message: "{0} <b> {1} tarihinideki vardiyası için {2} dk </b> fazla mesai talebini onaylamak istiyor musunuz ?"
    },
    timesheet: {
      employee: "Çalışan",
      employees: "Çalışanlar",
      date: "Tarih",
      type: "Türü",
      work_plan: "Çalışma Planı",
      shift: "Vardiya",
      clock_in: "Giriş",
      clock_in_title: "Giriş Zamanı",
      late: "Geç",
      reason: "Sebep",
      late_title: "Geç Giriş",
      it: "KT",
      it_title: "Kimlik Tipi",
      terminal: "Terminal",
      clock_out: "Çıkış",
      clock_out_title: "Çıkış Zamanı",
      early: "Erken",
      early_title: "Erken Çıkış",
      ewt: "BÇS",
      ewt_title: "Beklenen Çalışma Süresi",
      awt: "GÇS",
      twt_title: "Toplam Çalışma Süresi",
      twt: "TÇS",
      awt_title: "Gerçekleşen Çalışma Süresi",
      ot: "FM",
      ot_title: "Fazla Mesai",
      mt: "EM",
      mt_title: "Eksik Mesai",
      name: "Çalışan",
      time: "Zaman",
      identity_type: "Kimlik Türü",
      event_type: "Olay Türü",
      event_time: "Olay Zamanı",
      all_events: "Bütün Olaylar",
      status: "Durum",
      shift_name: "Vardiya Adı",
      branch: "Şube",
      unit: "Birim",
      team: "Takım",
      jobInfo: "Görev",
      staffNumber: "Sicil No",
      information: {
        work_day: "İş Günü",
        work_day_desc: "Personelin o gün işe geleceği anlamına gelir.",
        work_off: "Hafta Tatili",
        work_off_desc: "Personelin o gün hafta tatilidir.",
        public_holiday: "Resmi Tatil",
        public_holiday_desc: "Personelin o gün resmi tatilidir.",
        did_not_come_to_work: "İşe Gelmedi",
        did_not_come_to_work_desc: "Çalışan o gün vardiyası olmasına rağmen işe gelmedi.",
        on_leave: "İzinli",
        on_leave_desc: "Çalışan o gün izinlidir.",
        calculated: "Hesaplandı",
        calculated_desc: "Yeşil renkli yazıların hesaplama işlemi yapıldığı anlamına gelir.",
        not_calculated: "Hesaplanamadı",
        not_calculated_desc: "Kırmızı renkli yazıların hesaplanamadığı anlamına gelir."
      },
      total: "Toplam"
    },
    calendar: {
      holiday: "Resmi Tatil",
      off_day: "Hafta Tatili",
      breakday: "Dinlenme Günü",
      employee_overtime: "Çalışan bu tarihte işe gelirse fazla mesai olarak hesaplanır",
      employee_off_day: "Çalışanın haftalık tatilidir",
      employee_break_day: "Çalışanın dinlenme günüdür",
      shift_loading: "Idenfit vardiyaları oluşturuluyor",
      create_shift: "Vardiya Oluştur",
      shift_detail: "Vardiya Detayı",
      leave_type: "İzin Tipi",
      begin_time: "Başlangıç Saati",
      end_time: "Bitiş Saati",
      break_time: "Mola Süresi",
      shift_time: "Vardiya Süresi",
      clock_in_max_overtime: "Giriş Maximum Fazla Mesai",
      clock_out_max_overtime: "Çıkış Maximum Fazla Mesai",
      lately_tolerance: "Geç Kalma Toleransı",
      early_tolerance: "Erken Çıkma Toleransı",
      overtime: "Fazla Mesai",
      early_clock_out_tolerance: "Erken Çıkma Toleransı",
      lately_clock_in_tolerance: "Geç Kalma Toleransı",
      max_clock_in_overtime_in_minutes: "Giriş Maksimum Fazla Mesai",
      max_clock_out_overtime_in_minutes: "Çıkış Maksimum Fazla Mesai",
      shift_type: "Vardiya Tipi",
      count_as_overtime: "Fazla mesai sayılsın",
      total_work_time: "Toplam Çalışma Süresi",
      selectWeekends: "Hafta Tatili Günleri",
      selectBreaks: "Dinlenme Günleri",
      overtime_request: {
        approve_title: "Fazla Mesai Onaylama",
        add_overtime: "Fazla Mesai Talebi Oluştur",
        detail_overtime: "Fazla Mesai Talebi Detayı",
        date: "Vardiya Tarihi",
        workplan: "Vardiya",
        overtime_in_minutes: "Mesai Süresi",
        request_status: "Durum",
        request_date: "Talep Tarihi",
        approval_date: "Onaylama Tarihi",
        period: "Periyod",
        history: "Onaylama Geçmişi",
        periods: {
          CLOCK_IN: "Mesai Giriş",
          CLOCK_OUT: "Mesai Çıkış",
          CLOCK_IN_OUT: "Mesai Giriş & Çıkış"
        },
        approved:
          "{0} <b> {1} tarihinideki vardiyası için {2} dk </b> fazla mesai talebini onaylamak istiyor musunuz ?",
        rejected:
          "{0} <b> {1} tarihinideki vardiyası için {2} dk </b> fazla mesai talebini reddetmek istiyor musunuz ?",
        approval_to_manager: "Fazla Mesai Yöneticisine onay gitsin",
        not_approval_to_manager: "Fazla Mesai Yöneticisine onay gitmesin",
        pending_approval_manager: "Onayı Beklenen Yönetici",
        processes: {
          approved: "Talebi onayladı",
          pending: "Onay vermesi bekleniyor",
          stopped: "Talep reddedildiği için onaylama süreci durduruldu",
          waiting: "Bir önceki yöneticinin onaylamasını bekliyor",
          denied: "Talep reddedildi"
        }
      },
      multiple_shift_deleting: "Toplu Vardiya Silme"
    },
    max_overtime_in_minutes_warning_message:
      "Fazla mesai talebiniz vardiyanız ile birlikte 11 saati geçtiğinden dolayı talebiniz oluşturulamıyor",
    totalWorkingTimeInMinutes: "Toplam Çalışma Süresi"
  }
};
